export default {
  pleaseEnterKeywords: 'please enter keywords',
  create: 'create',
  search: 'search',
  code: 'code',
  name: 'name',
  describe: 'describe',
  remarks: 'remarks',
  import: 'import',
  more: 'more',
  edit: 'edit',
  delete: 'delete',
  export: 'export',
  pleaseSelect: 'please select',
  cancel: 'cancel',
  save: 'save',
  operate: 'operate',
  seqNo: 'seqNo',
  close: 'close',
  confirm: 'confirm',
  description: 'description',
  tip: 'tip',
  view: 'view',
  valueType: 'value type',
  importFromOwl: 'import from owl',
  changeStatusWorking: 'are you sure to change the class status to: working',
  deleteTheClass: 'are you sure to delete the class',
  selectClass: 'please select a class first',
  deleteClassAttribute: 'Whether delete the selected class properties',
  deleteTheClassAttribute: 'Please select the class attribute to delete',
  deleteRecord: 'are you sure to delete this record',
  dataType: 'data type',
  relationIdentify: 'relation identify',
  deleteAttribute: 'are you sure to delete this attribute',
  standardAttributeDetail: 'standard attribute detail',
  editStandaardAttribute: 'edit standard attribute',
  createStandardAttribute: 'create standard attribute',
  importFromExcel: 'import from excel',
  downloadTemplete: 'download templete',
  uploadFile: 'upload file',
  complete: 'complete',
  clickDownloadTemplete:
    'click the icon to download the template and fill in the information, if the download is completed, click',
  nextStep: 'next step',
  onlyOne: 'only one file can be uploaded at a time, or',
  clickUpload: 'click upload',
  downloadUploadResult: 'file upload completed (click the icon to download the import results)',
  uploadSuccess: 'upload success',
  previous: 'previous step',
  viewDownloadResult: 'please download the document to view the upload results',
  loginExpired: 'login has expired, please login again',
  loginAgain: 'please login again',
  pleaseSelectDate: 'please select the date',
  theDecimalPointMustGreaterThan0: 'the decimalPoint must greater than 0',
  theLengthMustGreaterThan0: 'the length must greater than 0',
  valueTypeStringMusthEnterTheLength: 'the valueType is string,please enter the length',
  valueTypeDecimalMusthEnterTheLength: 'the valueType is decimals,please enter the length',
  theDecimalPointCannotExceed30: 'the decimalPoint cannot exceed 30',
  theLengthCannotExceed65: 'the length cannot exceed 65',
  serialNumber: 'No.',
  hint: 'Prompt',
  Sure: 'Confirm',
  Cancel: 'Cancel',
  ContinueExportingAllData:
    'No Record is Currently Selected, The System Will Export All Data in The System By Default, This Operation Will Take a Long Time, Please Confirm Whether You Want to Continue',
  sequenceNumberMustThanZero: 'The Sequence Number Must Be a Positive Integer Greater Than 0',
  LengthCannotExceedTenCharacters: 'Length Cannot Exceed 10 Characters',
  SerialNumberCannotBeEmpty: 'Serial Number Cannot Be Empty',
  to: 'to',
  state: 'state',
  type: 'type',
  Result: 'Result',
  Refresh: 'Refresh',
  Retry: 'Retry',
  Restore: 'Restore',
  batchDeletion: 'batchDeletion',
  selectRule: 'selectRule',
  pleaseChoose: 'Please Choose',
  PleaseSearchForTheName: 'Please Search for The Name',
  new: 'New',
  listPresentation: 'List Presentation',
  cardDisplay: 'Card Display',
  yes: 'Yes',
  no: 'No',
  pleaseEnter: 'Please Enter',
  enterLabelName: 'Please enter label name',
  confirmDeleteLabel: 'Are you sure to delete this label?',
  enterNameOrCode: 'Please enter name or code',
  enterTheDictionaryValue: 'Please enter the dictionary value',
  saveSuccessFul: 'Save successful',
  addDictionaryEntries: 'Add dictionary entries',
  editDictionaryEntries: 'Edit dictionary entries',
  confirmDeleteReidentityGroup: 'Are you sure to delete this identity group?',
  addTo: 'Add',
  encode: 'Encode',
  selectExtendedProperties: 'Select extended properties',
  entityCode: 'code',
  entityCorrespondence: 'Entity correspondence',
  impactAnalysis: 'Impact analysis',
  dataOwner: 'Data owner',
  entityType: 'Entity type',
  inheritedAttributes: 'Inherited attributes',
  inheritEntities: 'Inherit entities',
  downloadFile: 'Download file',
  deleteFile: 'Delete file',
  titleCannotBeEmpty: 'Title cannot be empty',
  processTypeCannotBeEmpty: 'Process type cannot be empty',
  approverCannotBeEmpty: 'Approver cannot be empty',
  deadlineCannotBeEmpty: 'Deadline cannot be empty',
  confirmToDelete: 'Are you sure to delete?',
  confirmToDeleteForever: 'This operation will permanently delete, do you want to continue?',
  confirmToContinueAwaite: 'This may take a long time, please confirm whether to continue?',
  ruleExpressionsTips:
    'The attribute value generated by the rule expression has not been completed, please edit it before saving',
  assetCatalogTree: 'Asset catalog tree',
  noDataYet: 'No data yet',
  directoryTreeConfiguration: 'Directory tree configuration',
  addHierarchies: 'Add hierarchies',
  directory: 'Directory',
  expandByEntity: 'Expand by entity',
  recursiveOrNot: 'Is it recursive?',
  characteristicAttributes: '* attribute',
  associateTheParentEntity: 'Associate the parent entity',
  pleaseSelectDataType: 'Please select data type',
  onlyOneCanBeExpandedByEntity: 'Only one can be expanded by entity',
  selectTheCriteriaFirst: 'Please select the standard first',
  selectHierarchyWantToDelete: 'Please select the hierarchy to delete',
  deleteDataConfirm: 'Are you sure to delete this data?',
  keepAtLeastOneConfigurationDetail: 'Keep at least one configuration detail',
  collection: 'Collection',
  collectionSuccess: 'Collection successful',
  cancelCollectionSuccess: 'Cancel collection successful',
  searchTips:
    'Note: The search supports multiple word combination search, please connect the words with * (device*valve)',
  searchRange: 'Search Range',
  Data: 'Data',
  DocumentFullText: 'Document Full Text',
  searchResultTips: 'No data: please change the standard or search keywords',
  BrowsingPosition: 'Browsing Position',
  DownloadFiles: 'Download Files',
  BrowsingDocuments: 'Browsing Documents',
  UpgradeVersion: 'Upgrade Version',
  ViewHistory: 'View History',
  DocumentAssociation: 'Document Association',
  DocumentName: 'Document Name',
  filesPath: 'File Path',
  uploadTime: 'Upload Time',
  uploadUser: 'Upload User',
  NoDataNow: 'No Data For Now',
  documentCode: 'Document Code',
  documentVersion: 'Document Version',
  updataTime: 'Updata Time',
  Categories: 'Categories',
  fileType: 'File Type',
  file: 'File',
  zipFile: 'Zip File',
  synchronouslyCreatingDocuments: 'Synchronously Creating Documents',
  bitNumberTree: 'Bit Number Tree',
  documentTree: 'Document Tree',
  downloadProgress: 'Download Progress',
  successfulDeAssociation: 'Successful de-association',
  selectUnassociate: 'Select the data you want to unassociate',
  acquisitionTime: 'Acquisition Time',
  addAttributes: 'Add Attributes',
  addRules: 'Add Rules',
  templateProperties: 'Template Properties',
  baseProperties: 'Base Properties',
  noDateYet: 'No Date Yet',
  deactivated: 'Deactivated',
  oning: 'On',
  taskTypeName: 'Task Type Name',
  priority: 'Priority',
  startTime: 'Start Time',
  endTime: 'End Time',
  creationTime: 'Creation Time',
  lastModifiedTime: 'Last Modified Time',
  firingInterval: 'Firing Interval',
  selectStartTime: 'Please select a start time',
  selectEndTime: 'Please select a end time',
  enterTaskTypeName: 'Please enter a task type name',
  enterTaskTypeCode: 'Please enter a task type code',
  enterTaskTypeDes: 'Please enter a task type description',
  enterTaskTypePriority: 'Please enter a task type priority',
  enterTimeInterval: 'Please enter the time interval',
  typeName: 'Type Name',
  entityName: 'entityName',
  startDate: 'Start Date',
  endDate: 'End Date',
  reset: 'Reset',
  mainDatadescription: 'Main data type description',
  bindingEntities: 'Binding Entities',
  fileLists: 'File List',
  documentLists: 'Document List',
  documentListings: 'Document Listing',
  whetherMainData: 'Please select whether it is master data',
  selectWhetherType: 'Please select whether it is a type',
  folder: 'Folder',
  pleaseSelectFolder: 'Please select a folder',
  documentUpscaling: 'Document version upgrade',
  pleaseEnterFileName: 'Please enter the file name',
  associationSuccessful: 'Association successful',
  setAsMasterFile: 'Set as master file',
  delConfirm: 'Are you sure you want to delete?',
  attributeValue: 'Attribute value',
  codeOrName: 'Code or name',
  expandAll: 'Expand all',
  collapseThemAll: 'Collapse all',
  unfavorite: 'Unfavorite',
  favorites: 'Favorites',
  PleaseSelectLeibieName: 'Please select type name',
  dictionaryValues: 'Dictionary Values',
  objectEncodingCannotNull: 'The object encoding cannot be null',
  documentNameCannotEmpty: 'The document name cannot be empty',
  filterEntityCollection: 'Filter Entity Collection',
  filterDataLabels: 'Filter Data Labels',
  gotoEntityManagement: 'Go to Entity Management',
  goToDatasetManagement: 'Go to Dataset Management',
  displayStandardName: 'Display Standard Name',
  expand: 'Expand',
  collapse: 'Collapse',
  nodeName: 'Node name',
  pbsStructure: 'PBS Structure',
  enterEntityOrEntityCode: 'Please enter the entity name or entity code',
  tags: 'Tags',
  addNewProject: 'Add Project',
  engineeringCoding: 'Engineering Coding',
  engineeringName: 'Project Name',
  dataRightsCode: 'Data Rights Classification Code',
  subProjectCoding: 'Subproject Coding',
  theNameOfTheSubproject: 'Subproject Name',
  engineeringUnitCoding: 'Engineering Unit Coding',
  engineeringUnitName: 'Engineering Unit Name',
  addedAssociatedEntityDataObject: 'Added Associated Entity Data Object',
  pleaseEnterTheProjectCode: 'Please enter the project code',
  pleaseEnterAProjectName: 'Please enter the project name',
  pleaseEnterTheDataRightsCode: 'Please enter the data rights classification code',
  pleaseEnterTheSubprojectCode: 'Please enter the subproject code',
  pleaseEnterTheSubprojectName: 'Please enter the subproject name',
  pleaseEnterTheEngineeringUnitCode: 'Please enter the engineering unit code',
  pleaseEnterNameOfTheTngineeringUnit: 'Please enter the engineering unit name',
  addASubproject: 'Add a Subproject',
  editTheProject: 'Edit Project',
  addEngineeringUnit: 'Add Engineering Unit',
  editEngineeringUnit: 'Edit Subproject',
  editTheEngineeringUnit: 'Edit Engineering Unit',
  saveFailed: 'Save Failed',
  confirmTheDeletionTheNode: 'Confirm deletion of this node?',
  confirmTheDeletionOfTheSelectedData: 'Confirm deletion of the selected data?',
  downloadUploadErrorResult: "Faild to upload, click icon to download result"
}
